import { isSsr } from '../lib-ssr';
import { breakpointOf } from '../lib-breakpoints';
import { throttle } from '../lib-throttle';
/**
 * Set up ResizeObserver on element.
 * cb is called with entries: ResizeObserverEntry[]
 * Returns function that removes listener
 */
// ResizeObserverEntry[] can't be exported because of bug in @types/resize-observer-types
export function resizeListener(element, cb) {
    if (isSsr)
        return function () { };
    var ro = new window.ResizeObserver(cb);
    ro.observe(element);
    return function () { return ro.disconnect(); };
}
export function registerResizeListener(element, breakpointCb) {
    var currentBreakpoint = null;
    var cb = function () {
        var width = element.getBoundingClientRect().width;
        if (width > 0) {
            var newBreakpoint = breakpointOf(width);
            if (newBreakpoint !== currentBreakpoint) {
                currentBreakpoint = newBreakpoint;
                breakpointCb(currentBreakpoint);
            }
        }
    };
    var throttledFunc = throttle(cb);
    var disconnect = resizeListener(element, throttledFunc);
    cb();
    return function () {
        throttledFunc.cancel();
        return disconnect;
    };
}
